import React from 'react';

function IconButton(props) {
  if (props.hide) {
    return null;
  }
  const iconOnlyClass = props.titulo ? '' : ' icon-only-button';
  const iconClass = props.icon ? ` icon-${props.icon}` : '';
  return (
    <button
      type="button"
      className={`btn btn-${props.btnStyle}${iconOnlyClass}${iconClass}${props.className ? ` ${props.className}` : ''}`}
      onClick={props.onClick}
      title={props.mensagem}
      disabled={props.disabled}
      style={{
        fontFamily: 'tahoma, verdana, arial',
        borderRadius: '5px',
        borderTop: '0px',
        borderLeft: '0px',
        marginTop: '3px',
        boxShadow: '2px 2px #C0C0C0',
        ...props.style,
      }}
    >
      <i className={`pi pi-${props.icon}`}></i>
      { props.titulo }
    </button>
  );
}

export default IconButton;
